exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[type=\"file\"] {\r\n    display: none;\r\n} \r\n.progress {\r\n    display: none;\r\n}\r\n.custom-file-upload {\r\n    border: 1px solid #ccc;\r\n    display: inline-block;\r\n    padding: 6px 12px;\r\n    cursor: pointer;\r\n}\r\n.custom-file-upload:hover {\r\n    background-color: #d2d6de;\r\n    color: #fff;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/www/kh_indesso_web/src/app/components/media/document/document-selector/document-selector.component.css
// module id = ../../../../../src/app/components/media/document/document-selector/document-selector.component.css
// module chunks = 0